import DeleteSystemApprovalClaimModal from './DeleteSystemApprovalClaimModal'

export default DeleteSystemApprovalClaimModal
